import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";

export const selectorWebsiteUrlsForOfflineUse = (state) => state[KEY_REDUCER_SW].websiteUrls;